module.exports = __webpack_public_path__ + "img/zxjp.10c9b38.png";